module.exports = __webpack_public_path__ + "img/disease.7f490eef.jpg";